const BlogPosts = (domEl) => {

	let isLoading = false;
	let resetBeforeShowing = false;

	const timeline = domEl.querySelector('#timeline');
	const ghostItem1 = domEl.querySelector('.blog-post-ghost-1');
	const loadMoreButton = domEl.querySelector('.load-more-button');

	// Filters
	const posts_per_page = ( parseInt( domEl.getAttribute('data-posts_per_page')) > 0 ? parseInt(domEl.getAttribute('data-posts_per_page')) : 10 );
	let paged = ( parseInt( domEl.getAttribute('data-paged')) >= 0 ? parseInt(domEl.getAttribute('data-paged')) : 1 );
	const post_types = domEl.getAttribute('data-post_types');
	const post__not_in = domEl.getAttribute('data-post__not_in');
	const post__in = domEl.getAttribute('data-post__in');
	let offset = parseInt(domEl.getAttribute('data-offset'));
	const orderby = domEl.getAttribute('data-orderby');
	const order = domEl.getAttribute('data-order');
	const category = domEl.getAttribute('data-category');

	// Initialize
	loadMoreButton.addEventListener('click', (e) => {
		e.preventDefault();
		if(!isLoading) {
			getBatch();
		}
	});

	// Setup infinite scroll
	let observerInfiniteScroll = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				if(entry.intersectionRatio !== 0) {
					getBatch();
				}
			});
		},
		{rootMargin: "0px 0px 300px 0px"});
	observerInfiniteScroll.observe(loadMoreButton);


	const getBatch = () => {

		if(isLoading) {
			return false;
		}

		// Prepare to get a new batch
		domEl.classList.add('js-loading');
		isLoading = true;

		const formData = new FormData();
		formData.append('action', APP_Localize.action.getBatchPosts);
		formData.append('nonce', APP_Localize.nonce.getBatchPosts);
		formData.append('paged', paged);
		formData.append('offset', offset);
		formData.append('posts_per_page', posts_per_page);
		formData.append('post_types', post_types);
		formData.append('post__not_in', post__not_in);
		formData.append('post__in', post__in);
		formData.append('orderby', orderby);
		formData.append('order', order);
		if(category) {
			formData.append('category', category);
		}

		const header = new Headers({
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		});
		fetch(APP_Localize.ajaxUrl, {
			method		: 'POST',
			mode		: 'cors',
			header		: header,
			body		: formData,
			credentials	: 'same-origin',
			cache		: 'no-store',
		})
			.then(function(response) {
				if(response.status >= 200 && response.status < 300) return Promise.resolve(response);
				else return Promise.reject(new Error(response.statusText));
			})
			.then(function(response){
				return response.json();
			})
			.then( onBatchFetched )
			.catch(function(ex) {
				console.log('BlogPosts > parsing failed', ex);
			});
	};

	const onBatchFetched = (response) => {

		if(response.success) {
			if(paged === 1) {
				window.scroll({ top: 0, left: 0, behavior: 'smooth' });
			}

			// Update the history so we can go back and forth
			if(history.pushState) {
				// The current page number
				/** DEPRECATED 2023-08-07
				const uri = updateQueryStringParam('side', paged);
				window.history.pushState({path:uri},'',uri);
				 */
			}

			// Alter the timeline
			if(response.data.post_count <= 0 && paged === 1) {
				timeline.innerHTML = '';
				//$_no_results.style.display = 'block';
				hideLoadMoreBtn();
			}
			else if(response.data.post_count > 0) {

				//$_no_results.style.display = 'none';

				// Append the posts to the timeline
				if(resetBeforeShowing) {
					timeline.innerHTML = '';
				}

				//$_timeline.insertAdjacentHTML('beforeend', response.data.posts );
				ghostItem1.insertAdjacentHTML('beforebegin', response.data.posts);

				// Manage the load more button
				if(response.data.found_posts > 0) {
					if((paged * posts_per_page) >= response.data.found_posts || (offset + posts_per_page) >= response.data.found_posts) {
						hideLoadMoreBtn();
					}
					else {
						showLoadMoreBtn();
					}
				}

				// Per default - the single blog-post instances are hidden and only revealed via IntersectionObserverAnimation
				// We replicate that functionality
				document.querySelectorAll('.blog-post:not(.in-view)').forEach(el => { observer.observe(el) });

				// Prepare next
				paged++;
				offset += posts_per_page;
			}
			else
			{
				// No more posts to append
				if(loadMoreButton.length > 0) {
					hideLoadMoreBtn();
				}
			}

			resetBeforeShowing	= false;
		}

		// Re-enable load
		isLoading = false;
		domEl.classList.remove('js-loading');
	};

	let observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if(entry.intersectionRatio !== 0) {
				entry.target.classList.add('in-view');
				observer.unobserve(entry.target);
			}
		});
	},
	{rootMargin: "0px 0px 0px 0px"});

	const hideLoadMoreBtn = () => {
		if(loadMoreButton) {
			loadMoreButton.style.display = 'none';
		}
	};
	const showLoadMoreBtn = () => {
		if(loadMoreButton) {
			loadMoreButton.style.display = 'block';
		}
	};

	const updateQueryStringParam = (key, value, uri) => {
		if(!uri) {
			uri = window.location.href;
		}

		const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
		const separator = uri.indexOf('?') !== -1 ? '&' : '?';

		if(uri.match(re)) {
			return uri.replace(re, '$1' + key + "=" + value + '$2');
		}
		else {
			return (uri + separator + key + '=' + value);
		}
	};
};

export default BlogPosts;